import { Component, OnInit } from '@angular/core';

import { UserblockService } from './userblock.service';
import { SessaoUtil } from '../../../util/sessao-util';
import { TipoAcesso } from '../../../util/enum/tipo-acesso.enum';
import { UtilService } from '../../../util/util.service';

@Component({
    selector: 'app-userblock',
    templateUrl: './userblock.component.html',
    styleUrls: ['./userblock.component.scss']
})
export class UserblockComponent implements OnInit {
    user: any;
    constructor(public userblockService: UserblockService, private session: SessaoUtil) {

        this.user = {
            picture: 'assets/img/elias.jpg'
        };
    }

    ngOnInit() {
    }

    userBlockIsVisible() {
        return this.userblockService.getVisibility();
    }

    getTipoAcesso() : string{
      return !UtilService.empty(this.session) && !UtilService.empty(this.session.tipoAcesso) ? TipoAcesso[this.session.tipoAcesso] : '';
    }

    getNomeUsuarioLogado() : string{
      return !UtilService.empty(this.session) && !UtilService.empty(this.session.nomeUsuarioLogado) ? this.session.nomeUsuarioLogado : '';
    }

    getImamgeUsuario(){
      let img: string = 'assets/img/avatar.png';
      if(this.session.imagem != null && this.session.imagem != undefined){
        if(this.session.imagem.mime != null && this.session.imagem.mime != undefined
        && this.session.imagem.bytes != null && this.session.imagem.bytes != undefined ){
          img = 'data:' + this.session.imagem.mime + ';base64,' + this.session.imagem.bytes;
        }
      }
      return img;
    }
}



// WEBPACK FOOTER //
// ./src/app/layout/sidebar/userblock/userblock.component.ts